import { render, staticRenderFns } from "./DetailPickup.vue?vue&type=template&id=6f32fa91&scoped=true"
import script from "./DetailPickup.vue?vue&type=script&lang=ts"
export * from "./DetailPickup.vue?vue&type=script&lang=ts"
import style0 from "./DetailPickup.vue?vue&type=style&index=0&id=6f32fa91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f32fa91",
  null
  
)

export default component.exports